import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Route } from 'src/app/core/route.service';
import { SpSupportComponent } from './sp-support.component';

const routes: Routes = Route.withShell([
  { path: 'support', component: SpSupportComponent, data: { title: 'Support' } }
]);

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class SpSupportRoutingModule { }
